import React from 'react';

// Um modal genérico e bonito para confirmação de exclusão
export default function ExcluirModal({ isOpen, onClose, onConfirm, titulo, mensagem, item }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fadeIn">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden transform transition-all scale-100 animate-scaleIn">
        
        {/* Cabeçalho com ícone de alerta */}
        <div className="bg-red-50 p-6 flex flex-col items-center text-center border-b border-red-100">
          <div className="w-16 h-16 bg-red-100 text-red-500 rounded-full flex items-center justify-center mb-4 text-3xl shadow-sm animate-pulse-slow">
            🗑️
          </div>
          <h3 className="text-xl font-bold text-gray-800">{titulo || "Excluir Item?"}</h3>
          <p className="text-sm text-gray-500 mt-2 leading-relaxed">
            {mensagem || "Essa ação é irreversível. Tem certeza que deseja continuar?"}
          </p>
          
          {/* Exibe o nome do item a ser excluído, se houver */}
          {item && (
            <div className="mt-4 px-4 py-2 bg-white border border-red-100 rounded-lg text-red-600 font-bold text-xs uppercase tracking-wide shadow-sm">
              {item}
            </div>
          )}
        </div>

        {/* Botões de Ação */}
        <div className="p-4 flex gap-3 bg-gray-50">
          <button 
            onClick={onClose}
            className="flex-1 py-3 px-4 bg-white border border-gray-300 text-gray-700 rounded-xl font-bold hover:bg-gray-100 transition-colors text-sm"
          >
            Cancelar
          </button>
          <button 
            onClick={onConfirm}
            className="flex-1 py-3 px-4 bg-red-500 hover:bg-red-600 text-white rounded-xl font-bold shadow-md hover:shadow-lg transition-all text-sm flex items-center justify-center gap-2 active:scale-95"
          >
            <span>Sim, Excluir</span>
          </button>
        </div>
      </div>
    </div>
  );
}